import createSvgIcon from '../Utils/CreateSvgIcon';

export const Confetti = createSvgIcon(
  <>
    <path
      d="M3.79605 19.2674L8.71886 5.73173C8.76072 5.61609 8.83111 5.5129 8.92349 5.43172C9.01587 5.35054 9.12725 5.294 9.24731 5.26735C9.36737 5.2407 9.49222 5.2448 9.61027 5.27928C9.72832 5.31375 9.83576 5.37747 9.92261 5.46454L18.5364 14.0783C18.6232 14.1652 18.6867 14.2727 18.721 14.3906C18.7552 14.5086 18.7592 14.6334 18.7325 14.7533C18.7057 14.8732 18.6492 14.9845 18.568 15.0767C18.4869 15.169 18.3838 15.2393 18.2682 15.2811L4.73261 20.2039C4.60189 20.2517 4.46026 20.2611 4.32437 20.231C4.18849 20.201 4.06402 20.1328 3.96561 20.0344C3.86721 19.9359 3.79897 19.8115 3.76893 19.6756C3.73889 19.5397 3.7483 19.3981 3.79605 19.2674Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 6.75C15.75 6.75 15.75 4.5 18 4.5C20.25 4.5 20.25 2.25 20.25 2.25"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.5 1.5V3.75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20.25 10.5L21.75 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20.25 7.5L22.5 6.75" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M7.32104 9.57129L14.4292 16.6794"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.47912 18.4786L5.521 14.5205"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  'Confetti',
);
